import { Alert, AlertTitle, Collapse, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { Interweave } from 'interweave';

import { useEffect } from 'react';

import { AlertData } from '../context/alertContext';

const AlertStyled = styled(Alert)(() => ({
    position: 'fixed',
    zIndex: 1500,
    top: 16,
    right: 16,
    borderRadius: 5,
    boxShadow: '0px 3px 5px rgba(0,0,0,0.2)',
    maxWidth: 500,
    width: '100%',
}));

const ModalStatusAlert = styled(Alert)(() => ({
    position: 'absolute',
    zIndex: 1500,
    top: 35,
    right: 30,
    width: 275,
    borderRadius: 4,
    boxShadow: '0px 3px 5px rgba(0,0,0,0.2)',
}));

interface StatusAlertProps extends AlertData {
    handleClose: (open: boolean) => void;
    style?: React.CSSProperties;
}

const StatusAlert = ({
    alertTitle,
    message,
    open,
    severity = 'success',
    handleClose,
    autoHideDuration = 5000,
    isModal = false,
    style,
}: StatusAlertProps) => {
    useEffect(() => {
        if (open && autoHideDuration > 0) {
            setTimeout(() => handleClose(false), autoHideDuration);
        }
    }, [open, autoHideDuration, handleClose]);

    const AlertComponent = isModal ? ModalStatusAlert : AlertStyled;

    return (
        <Collapse in={open} timeout={200}>
            <AlertComponent
                style={style}
                severity={severity}
                action={
                    <IconButton
                        aria-label='close'
                        color='inherit'
                        size='small'
                        onClick={() => {
                            handleClose(false);
                        }}
                    >
                        <CloseIcon fontSize='inherit' />
                    </IconButton>
                }
            >
                <AlertTitle>
                    {alertTitle
                        ? alertTitle
                        : severity === 'error'
                          ? 'Error'
                          : severity === 'warning'
                            ? 'Warning'
                            : severity === 'info'
                              ? 'Info'
                              : 'Success'}
                </AlertTitle>
                <Interweave content={message} />
            </AlertComponent>
        </Collapse>
    );
};

export default StatusAlert;
